import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import LoginAdminMaintenanceDataService from "@/services/LoginAdminMaintenanceDataService";
import UserListDataService from "@/services/UserListDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const isNoData = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref(store.getters.showPageTitle);
const loginAdminList = reactive([]);
const inputUserId = ref("");
const confirmModalData= reactive([]);
const errormessage = ref("");

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getLoginAdminList();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tblLoginAdminHistoryBody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("divLoginAdminHistoryBody")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("divLoginAdminHistoryBody").style.width = "100%";
      } else {
        document.getElementById("divLoginAdminHistoryBody").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

// データ取得
const getLoginAdminList = () => {
  isLoading.value = true;
  loginAdminList.splice(0);
  isNoData.value = false;
  LoginAdminMaintenanceDataService.getLoginAdminList().then((response: ResponseData) => {
    if(response.data.allLoginAdminList != 0){
      for (let info of response.data.allLoginAdminList) {
        // 日付形式を変更する
        const createDate = new Date(Date.parse(info.createDateTime));
        info.createDateTime = createDate.toLocaleString("en-US", { hour12: false });
        if(info.updateDateTime){
          const updateDate = new Date(Date.parse(info.updateDateTime));
          info.updateDateTime = updateDate.toLocaleString("en-US", { hour12: false });
        }
      }
      loginAdminList.push(response.data.allLoginAdminList);
    }
    else{
      isNoData.value = true;
    }
    isLoading.value = false;
  })
  .catch((error: ResponseData) => {
    if(error.response.data.dbException != undefined){
      const firstError = error.response.data.dbException[0];
      alertMessage.value = i18n.t("err079") + i18n.t("err080").replace("errorMessageValue", firstError.message);
    }else {
      alertMessage.value = i18n.t("err079") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
    }
    alertState.value = "error";
    isLoading.value = false;
  });
};

// 入力チェック
const checkLoginAdminList = () => {
  errormessage.value = "";
  alertMessage.value = "null"
  alertState.value = "neutral";
  const data = {
    userId: inputUserId.value,
  };

  if (inputUserId.value.trim() == "") {
    errormessage.value = i18n.t("alt031");
  }
  else {
    validateUser(inputUserId.value)
      .then((result:any) => {
        if (!result) {
          errormessage.value = i18n.t("alt086");
        }
        else {
          LoginAdminMaintenanceDataService.checkLoginAdmin(data).then((response: ResponseData) => {
            if(response.data.checkLoginAdmin != 0){
              const checkStatus = response.data.checkLoginAdmin[0].status;
              if(checkStatus == '0' || checkStatus == '2'){
                errormessage.value = i18n.t("alt084");
              }
              else if(checkStatus == '1'){
                errormessage.value = i18n.t("alt085");
              }
              isLoading.value = false;
            }
            else{
              addLoginAdminList(data);
            }
          })
          .catch((error: ResponseData) => {
            if(error.response.data.dbException != undefined){
              const firstError = error.response.data.dbException[0];
              alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            }else {
              alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
          });
        }
      });            
  }
  isLoading.value = false;
}

// UserID保存チェック
const validateUser = (userID:string) => {
  const data = {
    userId: userID,
    isCheckFlg : true
  };

  return UserListDataService.getUserInformation(data)
    .then((response:any) => {
      if (response.data.length > 0) {
        return true;
      } else {
        return false;
      }
    })
    .catch((error: ResponseData) => {
      if(error.response.data.dbException != undefined){
        const firstError = error.response.data.dbException[0];
        alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue", firstError.message);
      }else {
        alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
      }
      alertState.value = "error";
      isLoading.value = false;
      return true;
    });
};

// Add処理
const addLoginAdminList = (data:any) => {
  alertMessage.value = "null"
  alertState.value = "neutral";

  const loginAdminInfo = {
    btnName:'',
    userId: data['userId'],
    status:'0',
    User:store.getters.cognitoUserName,
  };

  LoginAdminMaintenanceDataService.insertLoginAdmin(loginAdminInfo)
    .then((response: ResponseData) => {
        if(response.data.message == "success"){
          alertMessage.value = i18n.t("suc039");
          alertState.value = "success";
          isLoading.value = false;
          getLoginAdminList();
        }
    })
    .catch((error: ResponseData) => {
      if(error.response.data.dbException != undefined){
        const firstError = error.response.data.dbException[0];
        alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue", firstError.message);
      }else {
        alertMessage.value = i18n.t("err076") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
      }
      alertState.value = "error";
      isLoading.value = false;
    });
}

// Delete処理
const deleteLoginAdmin = (userID: any, btnName:string) => {
  alertMessage.value = "null"
  alertState.value = "neutral";

  const deleteAdminInfo = {
      btnName:btnName,
      userId: userID,
      status:"1",
      User:store.getters.cognitoUserName,
    };
    LoginAdminMaintenanceDataService.insertLoginAdmin(deleteAdminInfo)
    .then((response: ResponseData) => {
        if(response.data.message == "success"){
          alertMessage.value = i18n.t("suc040");
          alertState.value = "success";
          isLoading.value = false;
          getLoginAdminList();
        }
    })
    .catch((error: ResponseData) => {
      if(error.response.data.dbException != undefined){
        const firstError = error.response.data.dbException[0];
        alertMessage.value = i18n.t("err077") + i18n.t("err080").replace("errorMessageValue", firstError.message);
      }else {
        alertMessage.value = i18n.t("err077") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
      }
      alertState.value = "error";
      isLoading.value = false;
    });
}

// Activate処理
const activateLoginAdmin = (userID: any,btnName:string) => {
  alertMessage.value = "null"
  alertState.value = "neutral";

  const activateAdminInfo= {
      btnName:btnName,
      userId: userID,
      status:"2",
      User:store.getters.cognitoUserName,
    };
    LoginAdminMaintenanceDataService.insertLoginAdmin(activateAdminInfo)
    .then((response: ResponseData) => {
      if(response.data.message == "success"){
        alertMessage.value = i18n.t("suc041");
        alertState.value = "success";
        isLoading.value = false;
        getLoginAdminList();
      }
    })
    .catch((error: ResponseData) => {
      if(error.response.data.dbException != undefined){
        const firstError = error.response.data.dbException[0];
        alertMessage.value = i18n.t("err078") + i18n.t("err080").replace("errorMessageValue", firstError.message);
      }else {
        alertMessage.value = i18n.t("err078") + i18n.t("err080").replace("errorMessageValue",error.response.data.error);
      }
      alertState.value = "error";
      isLoading.value = false;
    });
}

// モーダル表示
const confirmModal = (userId: any, btnName:string) => {
  confirmModalData.splice(0);
  confirmModalData.push(userId);
  confirmModalData.push(btnName);
}

// DeleteとActivateボタン処理
const changeStatus = () => {
  inputUserId.value = "";
  errormessage.value = "";
  var userId = confirmModalData[0];
  var buttonName = confirmModalData[1];
  if(buttonName == "Delete"){
    deleteLoginAdmin(userId,buttonName);
  }
  else if(buttonName == "Activate"){
    activateLoginAdmin(userId,buttonName);
  }
}

const openLoginManualPDF = () => {
  window.open("成り代わり機能のマニュアル.pdf");
};

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, isNoData, alertMessage, alertState, i18n, title, loginAdminList, inputUserId, confirmModalData, errormessage, handleResize, getLoginAdminList, checkLoginAdminList, validateUser, addLoginAdminList, deleteLoginAdmin, activateLoginAdmin, confirmModal, changeStatus, openLoginManualPDF, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})